import { connect } from 'react-redux'
import {
  loadTemplates,
  loadTemplate,
  selectElementGroup,
  selectElementSubGroup,
  selectDepartment,
  searchTemplate,
  types,
} from '../../../../actions/elements_order'
import { createLoadingSelector } from '../../../../libs/requests_status_handlers'

const loadingSelector = createLoadingSelector([types.LOAD_TEMPLATE])

function mapStateToProps(state) {
  return {
    dictionaries: {
      elementGroups: state.elementsOrder?.dictionaries?.elementGroups,
      elementSubGroups: state.elementsOrder?.dictionaries?.elementSubGroups,
      departments: state.elementsOrder?.dictionaries?.departments,
    },
    filtered: {
      departments: state.elementsOrder?.filtered?.departments || [],
      elementSubGroups: state.elementsOrder?.filtered?.elementSubGroups || [],
    },
    currentElementGroup: state.elementsOrder?.currentElementGroup,
    currentDepartment: state.elementsOrder?.currentDepartment,
    currentElementSubGroup: state.elementsOrder?.currentElementSubGroup,
    currentTemplate: state.elementsOrder?.currentTemplate,
    currentTemplateLoading: loadingSelector(state),
    currentTemplateData: state.elementsOrder?.currentTemplateData,
    searchTerm: state.elementsOrder?.searchTerm,
    templates: state.elementsOrder?.templates,
    templatesLoading: state.elementsOrder?.templatesLoading,
  }
}

function mapDispatchToProps(dispatch) {
  return {
    loadTemplates: (filterParams) => dispatch(loadTemplates(filterParams)),
    loadTemplate: (templateId) => dispatch(loadTemplate(templateId)),
    selectElementGroup: (elementGroupId) => dispatch(selectElementGroup(elementGroupId)),
    selectElementSubGroup: (elementSubGroupId) => dispatch(selectElementSubGroup(elementSubGroupId)),
    selectDepartment: (departmentId) => dispatch(selectDepartment(departmentId)),
    searchTemplate: (searchTerm) => dispatch(searchTemplate(searchTerm)),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)
